<script>
    import "./inputDesign.css"
    import { createEventDispatcher } from "svelte";
    const dispatch = createEventDispatcher();
    import {getCurrentDate} from '../../../utils'

    export let type = 'text'
    export let value
    export let placeholder
    export let required
    export let id
    export let error = false;

const handleInput = e => {
    value = e.target.value;
    dispatch("input", value);
};

</script>

    <div class="input-title column-direction flex">
        <slot name="label"></slot>
        <slot name="label_dec"></slot>
    </div>
    <input
        {type}
        min={getCurrentDate()}
        {value}
        {placeholder}
        {required}
        {id}
        on:input={handleInput}
        class="form-input {error ? 'error' : ''}"
    />